import Cookie from 'js-cookie';
import { CONFIG_MENU_OPENED_COOKIE_NAME } from '@/constants';
export function isConfigInitialized(area) {
    return !!Cookie.get(`${CONFIG_MENU_OPENED_COOKIE_NAME}::${area}`);
}
export function initializeConfig(area) {
    Cookie.set(`${CONFIG_MENU_OPENED_COOKIE_NAME}::${area}`, 'true');
}
